module.exports = __webpack_public_path__ + "static/media/aws_logo.a91d9797.svg";